const e = {
  "pipeline-header": "pipeline-header"
};
export {
  e as default
};
